import { createRouter, createWebHistory } from "vue-router";
import { useAuthStore } from '@/stores/auth';

const routes = [
  { path: '/', name: 'root', redirect: '/dashboard' },
  {
    path: '/',
    component: () => import('@/layouts/Authenticated.vue'),
    meta: { requiresAuth: true },
    children: [
      { path: 'dashboard', name: 'dashboard', component: () => import('@/pages/Dashboard.vue') },
      {
        path: 'models',
        children: [
          {
            name: 'models.index',
            path: '', component: () => import('@/pages/models/Index.vue'),
          },
          {
            name: 'models.missing-values',
            path: 'missing-values', component: () => import('@/pages/models/MissingValues.vue'),
          },
          {
            name: 'models.show',
            path: ':id/:tab?',
            component: () => import('@/pages/models/Show.vue'),
          },
          {
            name: 'models.create',
            path: 'create',
            component: () => import('@/pages/models/Create.vue')
          }
        ]
      },
      { path: '/user', name: 'user', component: () => import('@/pages/User.vue') },
      { path: '/confirm-password', name: 'confirmPassword', component: () => import('@/pages/auth/ConfirmPassword.vue') },
    ]
  },
  {
    path: '/auth',
    component: () => import('@/layouts/Guest.vue'),
    meta: { isGuest: true },
    children: [
      { path: "/login", name: 'login', component: () => import('@/pages/auth/Login.vue') },
      { path: "/verify-email", name: 'verifyEmail', component: () =>import('@/pages/auth/VerifyEmail.vue') },
      { path: "/two-factor-challenge", name: 'twoFactorChallenge', component: () => import('@/pages/auth/TwoFactorChallenge.vue') },
      { path: "/forgot-password", name: 'forgotPassword', component: () => import('@/pages/auth/ForgotPassword.vue') },
      { path: "/reset-password/:token", name: 'resetPassword', component: () => import('@/pages/auth/ResetPassword.vue') }
    ]
  },
  {
    path: '/:pathMatch(.*)*',
    name: '404',
    component: () => import('@/pages/NotFound.vue'),
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior() {
    // always scroll to top
    return { top: 0 };
  },
});

router.beforeEach((to, from, next) => {
  const authStore = useAuthStore();

  if (to.meta.requiresAuth && !authStore.currentUser) {
    next({ name: "login" });
  } else if (to.meta.isGuest && authStore.currentUser) {
    next({ name: "dashboard" });
  } else {
    next();
  }
});

export default router;
